import DataTable from 'components/organisms/data-table'
import InventoryTableColumns from 'domains/inventory/molecules/inventory-table-columns'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  hiddenColumns  : PropTypes.array,
  onButtonClick  : PropTypes.func,
  tableStatus    : PropTypes.string,
  rowButtonProps : PropTypes.object,
  isLoading      : PropTypes.bool,
  initialFilter    : PropTypes.array,
  pricePermissions : PropTypes.object,
  filterOptions    : PropTypes.object
}

/**
 * Table to display Inventories list
 * @param {Array<Object>} data - array of inventory objects
 * @param {func} onFetchData - function that will call endpoint for data
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 *
 */
const InventoryTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  rowButtonProps,
  isLoading,
  initialFilter,
  pricePermissions,
  filterOptions
}) => {

  const { buttonText, buttonColour, onButtonClick, isButtonDisabled, extraButtons = [] } = rowButtonProps
  const columns                                                       = useMemo(
    () => InventoryTableColumns({
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick,
      pricePermissions,
      filterOptions,
      extraButtons
    }),
    [
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick,
      pricePermissions,
      filterOptions,
      extraButtons
    ]
  )

  return (
    <DataTable
      data={ data }
      columns={ columns }
      hiddenColumns={ hiddenColumns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      isLoading={ isLoading }
      initialFilter={ initialFilter }
    />
  )
}

InventoryTable.propTypes = propTypes

export default InventoryTable
